import { Box, Typography } from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import AdminTable from "../components/adminTable";
import GroupTable from "../components/groupTable";
import SearchInput from "../components/project/searchInput";

export default function Acconts() {
  const [selected, setSelected] = useState(1);
  const [valueSearch, setValueSearch] = useState();
  const gridRef = useRef();
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  return (
    <>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "23px",
          color: "#5b5757",
          mt: "43px",
        }}
      >
        ثبت نام کنندگان
      </Typography>
      <Box display="flex" alignItems={"center"} >
        <Box
          mt="14px"
          bgcolor="white"
          p="4px 7px"
          borderRadius="7px"
          display="flex"
          gap="5px"
          width="fit-content"
          mb="17px"
        >
          <Typography
            borderRadius="7px"
            p="5px 23px"
            sx={{ cursor: "pointer" }}
            bgcolor={selected !== 1 ? "" : "#127A92"}
            color={selected !== 1 ? "#4E4E4E" : "white"}
            onClick={() => setSelected(1)}
          >
            جهادگران
          </Typography>
          <Typography
            borderRadius="7px"
            p="5px 23px"
            sx={{ cursor: "pointer" }}
            bgcolor={selected !== 2 ? "" : "#127A92"}
            color={selected !== 2 ? "#4E4E4E" : "white"}
            onClick={() => setSelected(2)}
          >
            گروه‌ها
          </Typography>
        </Box>
        <SearchInput
          type="text"
          id="filter-text-box"
          onInput={onFilterTextBoxChanged}
          value={valueSearch}
          onChange={(e)=>setValueSearch(e.target.value)}
          mb="5px"
          mr="20px"
        />
      </Box>
      {/* {selected === 2 ? <GroupTable /> : */}
      <AdminTable gridRef={gridRef} selected={selected} />
      {/* } */}
    </>
  );
}
